import styles from './AnonMenu.module.less';
import { Button } from 'edcom-ui';
import { openLogin, openSignup } from '../../../services/regModal';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export default function AnonMenu({ mobileNavMenuOpen = false }) {
  return (
    <div className={styles.AnonMenu}>
      <a
        className={clsx(styles.login, !mobileNavMenuOpen && styles.fadeOut)}
        data-trigger="topnav"
        onClick={e => {
          e.preventDefault();
          openLogin('topnav');
        }}
      >
        Log In
      </a>
      <Button
        color={'dark-teal'}
        href={''}
        className={styles.register}
        onClick={e => {
          e.preventDefault();
          openSignup('topnav', { signUp: { title: null } });
        }}
      >
        Sign Up
      </Button>
    </div>
  );
}

AnonMenu.propTypes = {
  mobileNavMenuOpen: PropTypes.bool,
};
